import ContactSingleMessageModalController from './contact-single-message-modal';

export default class VoucherSingleMessageModalController extends ContactSingleMessageModalController {

    constructor($uibModalInstance, $injector, $scope, extendedInformation) {
        super($uibModalInstance, $injector, $scope, extendedInformation);

        this.voucher = this.extendedInformation.recipientModel;
    }

    _getPreviewUrl(recipient) {
        return `templates/${this.selectedTemplateId}/preview/voucher/${recipient.id}`;
    }

    _getSendRequestData() {
        const out = {
            ...super._getSendRequestData(),
            recipient_type: 'voucher',
            vouchers: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [this.recipientModel.id]
                    }
                ],
                count: 1
            }
        };

        delete out.contacts;

        return out;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/single-send/voucher-single-message-modal.js